import { z } from 'zod';

export const postcodeValidation = z
  .string()
  .min(1, {
    message: 'Postcode is required',
  })
  .min(3, {
    message: 'Postcode must be longer than or equal to 3 characters',
  })
  .max(10, {
    message: 'Postcode must be shorter than or equal to 10 characters',
  })
  .regex(/^[A-Za-z0-9]+(?:[\s-][A-Za-z0-9]+)?$/, {
    message:
      'Postcode must contain only Latin letters, digits, one space, or one hyphen, and must not start or end with a space or hyphen',
  })
  .refine(
    (value) => {
      return !/^[A-Za-z]+$/.test(value);
    },
    { message: 'Postcode must contain at least one digit, hyphen, or space' },
  )
  .refine(
    (value) => {
      const spaceCount = (value.match(/\s/g) ?? []).length;
      const hyphenCount = (value.match(/-/g) ?? []).length;
      return spaceCount <= 1 && hyphenCount <= 1;
    },
    { message: 'Postcode can contain at most one space and one hyphen' },
  )
  .transform((value) => {
    return value.toUpperCase().trim();
  });
